var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Novelty Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Novelty Line",
      "file": "novelty"
    }
  }, [_vm._v(" Special finished velvet with burn out & novelty printing. Jacquard & Emboss fabric with various patterns. Delicate flocking mesh with luxurious printing. Our R&D handles these items very skillfully. You can meet special items that you can't find anywhere else. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }